// extracted by mini-css-extract-plugin
module.exports = {"box":"box-3-opc0Uy","box_up":"box_up-14zaqaQp clearfix","box_down":"box_down-vWGM1rsM clearfix","pic":"pic-Pvh20Rmd","text":"text-1V112Qq9","detail":"detail-2AUO1fk0"};